<template>
  <div id="home">
    <el-backtop target=""></el-backtop>
    <Video />
    <Nosotros v-if="true" id="nosotros" />
    <Servicios v-if="true" id="servicios" />
    <!-- <Paralax v-if="true" id="Paralax" /> -->
    <Numeros v-if="true" id="infra" />
    <Banner v-if="true" id="banner" />
    <Calidad v-if="true" id="calidad" />
    <Comercial v-if="true" id="comercial" />
    <!-- <Contacto v-if="true" id="contacto" /> -->
    <Footer id="contacto"></Footer>
    <el-row
      ><el-col
        ><h6 class="footer-final">
          <center>{{ altEmpresa }}</center>
        </h6></el-col
      ></el-row
    >
  </div>
</template>

<script>
import Video from '@/components/new/video.vue'
import Nosotros from '@/components/new/nosotros.vue'
import Calidad from '@/components/new/calidad.vue'
import Numeros from '@/components/new/numeracion.vue'
import Servicios from '@/components/new/servicios.vue'
import Banner from '@/components/new/banners.vue'
import Comercial from '@/components/new/comercial.vue'
import Footer from '@/components/footer.vue'
// import Paralax from '../components/new/paralax.vue'

// import Contacto from '@/components/new/comercial.vue'
export default {
  components: { Video, Nosotros, Numeros, Servicios, Banner, Calidad, Comercial, Footer },
  data() {
    return {
      altEmpresa: null,
      anio: new Date(),
    }
  },
  mounted() {
    this.altEmpresa = 'LOG-IN FARMA S.R.L © ' + this.anio.getFullYear()
  },
}
</script>

<style lang="scss" scoped>
// Servicios // Servicios // import Servicios from "@/components/new/servicios.vue"
// import Infra from "@/components/new/infra.vue"; // import Galeria from "@/components/new/galeria.vue";
// import Mapa from "@/components/new/mapa.vue"; // import Contacto from "@/components/new/contacto.vue";
// , Infra, Galeria, Mapa, Contacto
.el-backtop {
  position: fixed;
  background-color: #bb643571;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: #409eff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 0 6px rgb(0 0 0 / 0%);
  cursor: pointer;
  z-index: 5;
}
.footer-final {
  color: #d35915;
  font-family: 'roboto-regular';
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  .footer-final {
    font-size: 16px;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .footer-final {
    font-size: 16px;
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .footer-final {
    font-size: 16px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .footer-final {
    font-size: 16px;
  }
}
@media screen and (min-width: 375px) and (max-width: 767px) {
  .footer-final {
    font-size: 14px;
  }
}
@media (max-width: 375px) {
  .footer-final {
    font-size: 14px;
  }
}
</style>
